<template>
  <div class="row ml-1">
    <div class="col">
      <strong class="d-block">Servicio:</strong>
      <span>{{ serviceTypeTitle }}</span>
    </div>
    <div class="col" v-if="!hideTeacherType">
       <ValidationProvider v-slot="{ errors }" name="Modalidad" rules="required" v-if="modalityList.length > 0">
        <CustomDropDown
          v-model="selectedModality"
          required
          :options="modalityList"
          fieldkey="id"
          fieldname="name"
          label="Modalidad:"
          placeholder="Seleccione"
          class="block-spacing"
          :error="disabledAll ? '' : errors[0]"
          :custom-error-msg="
            disabledAll ? '' : 'Seleccione la modalidad del servicio.'
          "
          :disabled="disabledAll || modalityList.length == 1"
          @input="$emit('on-change-modality', { ...selectedModality })"
        />
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        name="Tipo de Maestro:"
        rules="required"
      >
        <CustomDropDown
          v-model="selectedMasterType"
          required
          :options="masterTypeList"
          fieldkey="id"
          fieldname="name"
          label="Tipo de Maestro:"
          placeholder="Seleccione"
          class="block-spacing"
          :error="disabledMasterType || disabledAll ? '' : errors[0]"
          :custom-error-msg="
            disabledMasterType || disabledAll
              ? ''
              : 'Seleccione el tipo de maestro.'
          "
          :disabled="disabledMasterType || disabledAll"
          @input="$emit('on-change-master-type', { ...selectedMasterType })"
        />
      </ValidationProvider>
    </div>
    <div class="col">
      <ValidationProvider v-slot="{ errors }" name="Duración" rules="required">
        <CustomDropDown
          v-model="selectedDuration"
          :options="durationList"
          fieldkey="id"
          fieldname="name"
          label="Duración:"
          placeholder="Seleccione"
          class="block-spacing"
          :error="disabledAll ? '' : errors[0]"
          :custom-error-msg="
            disabledAll ? '' : 'Seleccione la duración del servicio. '
          "
          :disabled="disabledAll"
          @input="$emit('on-change-duration', { ...selectedDuration })"
        />
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        name="Frecuencia"
        rules="required"
      >
        <CustomDropDown
          v-model="selectedFrequency"
          :options="frequencyList"
          fieldkey="id"
          fieldname="name"
          placeholder="Seleccione"
          label="Frecuencia:"
          class="block-spacing"
          :error="disabledAll ? '' : errors[0]"
          :custom-error-msg="
            disabledAll ? '' : 'Seleccione la frecuencia del servicio.'
          "
          :disabled="disabledAll"
          @input="$emit('on-change-frequency', { ...selectedFrequency })"
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { CustomDropDown } from '@/components/common';
export default {
  name: 'DeafService',
  data() {
    return {
      selectedMasterType: null,
      selectedModality: null,
      selectedDuration: null,
      selectedFrequency: null,
    };
  },
  computed: {
    visualControlCode: () => 4,
  },
  props: {
    masterTypeList: {
      type: Array,
      default: () => [],
    },
    modalityList: {
      type: Array,
      default: () => [],
    },
    durationList: {
      type: Array,
      default: () => [],
    },
    frequencyList: {
      type: Array,
      default: () => [],
    },
    serviceTypeTitle: {
      type: String,
      default: () => 'Servicio para Sordos',
    },
    disabledMasterType: {
      type: Boolean,
      default: () => true,
    },
    disabledAll: {
      type: Boolean,
      default: () => false,
    },
    hideTeacherType: {
      type: Boolean,
      default: () => false,
    },
  },
  watch:{
     modalityList(value) {
      if (value && value.length == 1) {
        this.selectedModality = { id: value[0].id, name: value[0].name };        
      }    
    },
  },
  components: {
    CustomDropDown,
    ValidationProvider,
  },
};
</script>

<style scoped>
.block-spacing {
  margin-bottom: 30px;
}

.block-spacing >>> .invalid {
  position: absolute;
  font-size: 13px;
  margin-left: 5px;
}
</style>
